// Login/Register
import login from './login';
import register from './register';
import resetPassword from './resetPassword';
import qualification from './qualification';
import dashboard from './dashboard';
import errors from './errors';

export const routes = [
    {
        path: '/:pathMatch(.*)*',
        redirect: '404',
    },
    ...dashboard,
    ...login,
    ...register,
    ...resetPassword,
    ...qualification,
    ...errors,
];
